// extracted by mini-css-extract-plugin
module.exports = {"lhsWrapper":"LoginLhs_lhsWrapper__32Ifo","login1":"LoginLhs_login1__3RYoN","welcome":"LoginLhs_welcome__1XDRi","logo":"LoginLhs_logo__2wY_f","lhsText":"LoginLhs_lhsText__2n7iL"};